import React from 'react';
import styled from 'styled-components';

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.6rem 0.75rem;
  width: 100%;
  transition: all 0.2s ease;
  box-sizing: border-box;
  flex: 1;
  min-width: 0; /* Permite que o flex item encolha abaixo do seu conteúdo */
  
  &:focus-within {
    border-color: ${props => props.theme.primary || '#e74c3c'};
    box-shadow: 0 0 0 3px ${props => props.theme.primary ? `${props.theme.primary}1A` : 'rgba(231, 76, 60, 0.1)'};
  }
`;

const Label = styled.label`
  font-size: 0.7rem;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.1rem;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

const Input = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 1rem;
  color: #2d3748;
  padding: 0;
  font-family: inherit;
  
  /* Remove -webkit-text-security if it's being applied by some browser extension or other CSS */
  -webkit-text-security: none !important;

  &[type="password"] {
    -webkit-text-security: disc !important;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #cbd5e0;
  }
`;

const Select = styled.select`
  width: 100%;
  border: none;
  background: transparent;
  font-size: 1rem;
  color: #2d3748;
  padding: 0;
  font-family: inherit;
  cursor: pointer;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }
`;

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLSelectElement> {
  label: string;
  as?: 'input' | 'select';
  rightElement?: React.ReactNode;
}

const FormInput: React.FC<FormInputProps> = ({ label, as = 'input', rightElement, ...props }) => {
  return (
    <FormGroup>
      <Label>{label}</Label>
      {as === 'select' ? (
        <Select {...(props as React.SelectHTMLAttributes<HTMLSelectElement>)} />
      ) : (
        <InputWrapper>
          <Input {...(props as React.InputHTMLAttributes<HTMLInputElement>)} />
          {rightElement}
        </InputWrapper>
      )}
    </FormGroup>
  );
};

export default FormInput;
